import { useState } from 'react';

/**
 * Écran de développement, jamais affiché dans Discord.
 *
 * Au navigateur il n'y a pas d'autorisation Discord à obtenir : on ouvre une
 * session comme le site, par identifiant et mot de passe. C'est ce qui permet
 * de travailler avec un rechargement de page plutôt qu'en fermant et rouvrant
 * l'Activity à chaque modification.
 */
export default function ConnexionLocale({ onConnexion }) {
  const [identifiant, setIdentifiant] = useState('');
  const [motdepasse, setMotdepasse] = useState('');
  const [erreur, setErreur] = useState(null);
  const [enCours, setEnCours] = useState(false);

  const envoyer = async (evenement) => {
    evenement.preventDefault();
    setErreur(null);
    setEnCours(true);

    try {
      await onConnexion(identifiant.trim(), motdepasse);
    } catch (e) {
      setErreur(e.message);
    } finally {
      setEnCours(false);
    }
  };

  return (
    <div className="centre">
      <h1 className="titre">Pop Movie</h1>
      <p className="discret">
        Mode développement — hors de Discord, il faut ouvrir une session à la main.
      </p>

      <form onSubmit={envoyer} className="formulaire">
        <input
          type="text"
          placeholder="Identifiant"
          autoComplete="username"
          value={identifiant}
          onChange={(e) => setIdentifiant(e.target.value)}
          required
        />
        <input
          type="password"
          placeholder="Mot de passe"
          autoComplete="current-password"
          value={motdepasse}
          onChange={(e) => setMotdepasse(e.target.value)}
          required
        />
        <button type="submit" disabled={enCours}>
          {enCours ? 'Connexion…' : 'Se connecter'}
        </button>
      </form>

      {erreur && <p className="erreur">{erreur}</p>}
    </div>
  );
}
